import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  id: "kt_aside_menu_wrapper",
  ref: "scrollElRef",
  class: "hover-scroll-overlay-y",
  "data-kt-scroll": "true",
  "data-kt-scroll-activate": "{default: false, lg: true}",
  "data-kt-scroll-dependencies": "#kt_aside_logo",
  "data-kt-scroll-height": "auto",
  "data-kt-scroll-offset": "0",
  "data-kt-scroll-wrappers": "#kt_aside_menu"
}
const _hoisted_2 = {
  id: "menu",
  class: "sidebar-nav",
  role: "navigation",
  "aria-label": "Main navigation"
}
const _hoisted_3 = {
  key: 0,
  class: "menu-item"
}
const _hoisted_4 = { class: "menu-content pt-8 pb-2" }
const _hoisted_5 = { class: "menu-section text-muted text-uppercase fs-8 ls-1" }
const _hoisted_6 = {
  key: 0,
  class: "menu-item"
}
const _hoisted_7 = ["href", "data-title", "onClick"]
const _hoisted_8 = { class: "menu-icon fa-stack" }
const _hoisted_9 = {
  key: 0,
  class: "badge2"
}
const _hoisted_10 = { class: "menu-title" }
const _hoisted_11 = {
  key: 0,
  class: "badge badge-primary ms-1"
}
const _hoisted_12 = { class: "menu-icon fa-stack" }
const _hoisted_13 = {
  key: 1,
  class: "menu-title"
}
const _hoisted_14 = { class: "menu-title" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("ul", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.MenuConfig, (item, i) => {
        return (_openBlock(), _createElementBlock(_Fragment, { key: i }, [
          (item.heading)
            ? (_openBlock(), _createElementBlock("li", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.translate(item.heading)), 1)
                ])
              ]))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.pages, (menuItem, j) => {
            return (_openBlock(), _createElementBlock(_Fragment, { key: j }, [
              (menuItem.heading && !menuItem.sub)
                ? (_openBlock(), _createElementBlock("li", _hoisted_6, [
                    _createVNode(_component_router_link, {
                      to: menuItem.route
                    }, {
                      default: _withCtx(({ href, navigate, isActive, isExactActive }) => [
                        _createElementVNode("a", {
                          class: _normalizeClass([
                  (isActive || _ctx.isRouteActive(menuItem.route)) && 'active',
                  isExactActive && 'active',
                  menuItem.heading === 'aside.menu.pages.userAssets' && 'menu-link--user-assets'
                ]),
                          href: href,
                          "data-title": _ctx.translate(menuItem.heading),
                          onClick: navigate
                        }, [
                          _createElementVNode("span", _hoisted_8, [
                            _createElementVNode("i", {
                              class: _normalizeClass([menuItem.fontIcon, "bi"])
                            }, null, 2),
                            (menuItem.badge)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(menuItem.badge), 1))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("span", _hoisted_10, [
                            _createTextVNode(_toDisplayString(_ctx.translate(menuItem.heading)) + " ", 1),
                            (menuItem.badgeInline)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(menuItem.badgeInline), 1))
                              : _createCommentVNode("", true)
                          ])
                        ], 10, _hoisted_7)
                      ]),
                      _: 2
                    }, 1032, ["to"])
                  ]))
                : (menuItem.heading && menuItem.sub)
                  ? (_openBlock(), _createElementBlock("li", {
                      key: 1,
                      class: _normalizeClass([
              'menu-item',
              'menu-accordion',
              menuItem.heading === 'aside.menu.pages.assets' && 'menu-accordion--assets',
              { 'show': _ctx.hasActiveChildren(menuItem.route, menuItem.sub) }
            ]),
                      "data-kt-menu-sub": "accordion"
                    }, [
                      _createElementVNode("span", {
                        class: "menu-link",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toggleSubmenu($event)))
                      }, [
                        _createElementVNode("span", _hoisted_12, [
                          _createElementVNode("i", {
                            class: _normalizeClass([menuItem.fontIcon, "bi"])
                          }, null, 2)
                        ]),
                        (menuItem.route)
                          ? (_openBlock(), _createBlock(_component_router_link, {
                              key: 0,
                              to: menuItem.route,
                              class: _normalizeClass(["menu-title", { active: _ctx.isRouteActive(menuItem.route) }])
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.translate(menuItem.heading)), 1)
                              ]),
                              _: 2
                            }, 1032, ["to", "class"]))
                          : (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(_ctx.translate(menuItem.heading)), 1)),
                        _cache[1] || (_cache[1] = _createElementVNode("span", { class: "menu-arrow" }, null, -1))
                      ]),
                      _createElementVNode("ul", {
                        class: _normalizeClass([{ show: _ctx.hasActiveChildren(menuItem.route, menuItem.sub) }, "menu-sub menu-sub-accordion"])
                      }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menuItem.sub, (item2, k) => {
                          return (_openBlock(), _createElementBlock("li", {
                            key: k,
                            class: "menu-item"
                          }, [
                            (item2.heading)
                              ? (_openBlock(), _createBlock(_component_router_link, {
                                  key: 0,
                                  to: item2.route,
                                  class: _normalizeClass({ active: _ctx.isExactRouteActive(item2.route) })
                                }, {
                                  default: _withCtx(() => [
                                    _cache[2] || (_cache[2] = _createElementVNode("span", { class: "menu-bullet" }, [
                                      _createElementVNode("span", { class: "bullet bullet-dot" })
                                    ], -1)),
                                    _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.translate(item2.heading)), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["to", "class"]))
                              : _createCommentVNode("", true)
                          ]))
                        }), 128))
                      ], 2)
                    ], 2))
                  : _createCommentVNode("", true)
            ], 64))
          }), 128))
        ], 64))
      }), 128)),
      _cache[3] || (_cache[3] = _createElementVNode("li", { class: "menu-item" }, [
        _createElementVNode("div", { class: "menu-content" }, [
          _createElementVNode("div", { class: "separator mx-1 my-4" })
        ])
      ], -1))
    ])
  ], 512))
}